<template>
  <div>
    <div>
      <!-- <Tag
        v-for="item in count"
        :key="item"
        :name="item"
        closable
        @on-close="handleClose2"
      >标签{{ item + 1 }}</Tag>
      <Input search enter-button placeholder="Enter something..."/>
      <Button icon="ios-add" type="dashed" size="small" @click="handleAdd">添加条件</Button>-->
      <Button type="primary" icon="ios-search" @click="searchByConditionsView">检索条件</Button>
    </div>

    <!-- 模态框 -->
    <div>
      <Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>检索条件</span>
        </p>
        <div style="text-align:center">
          <CheckboxGroup v-model="selectedCondition" class="check_grop">
            <div>
              <Row>
                <Col span="12">
                  <Checkbox label="meterId">
                    <span>设备编号</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Input v-model="meterIdModel" placeholder="请输入设备编号" style="width: 150px" />
                </Col>
              </Row>
            </div>
            <div>
              <Row>
                <Col span="12">
                  <Checkbox label="openAddress">
                    <span>开户地址</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Cascader
                    v-model="openAddressModel"
                    :data="addressData"
                    filterable
                    change-on-select
                    trigger="hover"
                    style="width: 150px;margin-left:7%"
                  ></Cascader>
                </Col>
              </Row>
            </div>
            <div>
              <Row>
                <Col span="12">
                  <Checkbox label="timeStamp">
                    <span>时间区间</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Tooltip
                    transfer
                    max-width="300px"
                    placement="top"
                    :disabled="timeStampModel == undefined || timeStampModel[0] == ''"
                  >
                    <div slot="content">
                      <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[0])}}</span>
                      <br />
                      <span style="margin-left:50%">~</span>
                      <br />
                      <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[1])}}</span>
                    </div>
                    <DatePicker
                      v-model="timeStampModel"
                      type="daterange"
                      split-panels
                      placeholder="请选择时间区间"
                      style="width: 150px"
                    ></DatePicker>
                  </Tooltip>
                </Col>
              </Row>
            </div>
            <div>
              <Row>
                <Col span="12">
                  <Checkbox label="occurType">
                    <span>报警类型</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Select v-model="occurTypeModel" style="width:150px" placeholder="请选择报警类型">
                    <Option
                      v-for="(value, key) in commandEnum"
                      :value="key"
                      :key="key"
                    >{{value.name}}({{key}})</Option>
                  </Select>
                </Col>
              </Row>
            </div>
            <div>
              <Row>
                <Col span="12">
                  <Checkbox label="orderWay">
                    <span>排序方式</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Select v-model="orderWayModel" style="width:150px" placeholder="请选择排序方式">
                    <Option value="occurTime">报警时间</Option>
                    <Option value="abnormalType">报警类型</Option>
                    <Option value="meterId">设备编号</Option>
                    <Option value="receiveTime">接收时间</Option>
                  </Select>
                </Col>
              </Row>
            </div>

            <div>
              <Row>
                <Col span="12">
                  <Checkbox label="autoFresh">
                    <span>自动刷新</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Select v-model="autoFreshModel" style="width:150px" placeholder="请选择自动刷新间隔">
                    <Option value="300">300s</Option>
                    <Option value="120">120s</Option>
                    <Option value="60">60s</Option>
                    <Option value="30">30s</Option>
                    <Option value="5">5s</Option>
                  </Select>
                </Col>
              </Row>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button type="info" size="large" long @click="searchByCondition">检索</Button>
        </div>
      </Modal>
    </div>

    <br />
    <div style="width:85%">
      <Table
        :class="{table}"
        border
        stripe
        :height="height * 0.7"
        :width="width * 0.8"
        :loading="loading"
        :columns="columns1"
        :data="data1"
      ></Table>
    </div>
    <br />
    <Page
      :current="pageNo"
      :total="pageTotal"
      :page-size="pageSize"
      :page-size-opts="[5, 10, 20, 30, 40]"
      show-sizer
      show-total
      @on-change="changePage"
      @on-page-size-change="changePageSize"
    />
  </div>
</template>

<script>
export default {
  name: "abnormal_detailed",
  destroyed() {
    if (this.interval != undefined) {
      clearInterval(this.interval);
    }
  },
  mounted() {
    // this.tableHeight =
    //   window.innerHeight - this.$refs.table.$el.offsetTop - 160;
  },
  created() {
    var that = this;
    this.request(that);
    this.getAddresTree();
  },
  methods: {
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, new Date(date));
    },
    getAddresTree() {
      var that = this;
      $.ajax({
        url: "/api/getAddressTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressData = data.body[0].children;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "地址获取异常"
          });
        }
      });
    },
    request(that) {
      that.pageNo = 1;
      $.ajax({
        url: "/api/getAbnormalDetailed",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: 1,
          amount: that.pageSize,
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          console.log(data);

          that.data1 = data.body.list;
          that.pageTotal = data.body.count;
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },

    ok() {},
    cancel() {},
    del() {},
    // 修改页面容量
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      var that = this;
      this.request(that);
    },
    // 修改
    changePage(index) {
      this.pageNo = index;
      var that = this;
      that.loading = true;
      this.pageNo = 1;
      $.ajax({
        url: "/api/getAbnormalDetailed",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: index,
          amount: that.pageSize,
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.data1 = data.body.list;
            that.pageTotal = data.body.count;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.data1 = data.body.list;
          that.pageTotal = data.body.count;
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    // 按条件检索点击事件
    searchByCondition() {
      this.requestBody = {};
      clearInterval(this.interval);
      for (var temp in this.selectedCondition) {
        if (this.selectedCondition[temp] == "meterId") {
          if (this.meterIdModel == "") {
            continue;
          }

          this.requestBody["meterId"] = this.meterIdModel;
          // requestBody.set("commandId", this.commandIdModel);
        }
        if (this.selectedCondition[temp] == "openAddress") {
          if (this.openAddressModel == "") {
            continue;
          }

          this.requestBody["openAddress"] = this.openAddressModel[
            this.openAddressModel.length - 1
          ];
          // requestBody.set("deviceId", this.deviceIdModel);
        }
        if (this.selectedCondition[temp] == "occurType") {
          if (this.occurTypeModel == "") {
            continue;
          }

          this.requestBody["occurType"] = this.occurTypeModel;
          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition[temp] == "orderWay") {
          if (this.orderWayModel == "") {
            continue;
          }

          this.requestBody["orderWay"] = this.orderWayModel;
          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition[temp] == "autoFresh") {
          if (this.autoFreshModel == "") {
            continue;
          }
          var that = this;
          this.interval = setInterval(
            this.request,
            this.autoFreshModel * 1000,
            this
          );

          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition[temp] == "timeStamp") {
          if (this.timeStampModel[0] == "" || this.timeStampModel[1] == "") {
            continue;
          }

          let startYear = this.timeStampModel[0].getFullYear().toString();
          let startMonth =
            this.timeStampModel[0].getMonth() >= 9
              ? (this.timeStampModel[0].getMonth() + 1).toString()
              : "0" + (this.timeStampModel[0].getMonth() + 1);
          let startDate =
            this.timeStampModel[0].getDate() >= 9
              ? this.timeStampModel[0].getDate().toString()
              : "0" + this.timeStampModel[0].getDate();

          let endYear = this.timeStampModel[1].getFullYear().toString();
          let endMonth =
            this.timeStampModel[1].getMonth() >= 9
              ? (this.timeStampModel[1].getMonth() + 1).toString()
              : "0" + (this.timeStampModel[1].getMonth() + 1);
          let endDate =
            this.timeStampModel[1].getDate() >= 9
              ? this.timeStampModel[1].getDate().toString()
              : "0" + this.timeStampModel[1].getDate();

          this.requestBody["timeStamp"] =
            startYear +
            "/" +
            startMonth +
            "/" +
            startDate +
            "-" +
            endYear +
            "/" +
            endMonth +
            "/" +
            endDate;
          // requestBody.set(
          //   "timeStamp",
          //   startYear +
          //     "/" +
          //     startMonth +
          //     "/" +
          //     startDate +
          //     "-" +
          //     endYear +
          //     "/" +
          //     endMonth +
          //     "/" +
          //     endDate
          // );
        }
      }

      // 调用接口查询
      var that = this;
      that.loading = true;
      this.modal8 = false;
      this.pageNo = 1;
      $.ajax({
        url: "/api/getAbnormalDetailed",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.$Notice.success({
              title: "提示",
              desc: "获取报警信息成功"
            });
            console.log(data);
            that.data1 = data.body.list;
            that.pageTotal = data.body.count;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    // 显示条件检索页面
    searchByConditionsView() {
      this.modal8 = true;
    },
    handleClose2(event, name) {
      const index = this.count.indexOf(name);
      this.count.splice(index, 1);
    }
  },
  data() {
    return {
      columns1: [
        {
          title: "设备编号",
          key: "meterId",
          align: "center",
          width: 150
        },
        {
          title: "报警类型",
          key: "abnormalName",
          align: "center",
          width: 140
        },
        {
          title: "报警动作",
          key: "occurType",
          align: "center",
          width: 100
        },
        {
          title: "报警时间",
          key: "occurTime",
          align: "center",
          width: 180
        },
        {
          title: "报警参数",
          key: "abnormalField",
          align: "left",
          width: 500
        },
        {
          title: "地址",
          key: "completeAddress",
          align: "left",
          width: 450
        }
      ],
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      data1: [],
      loading: true,
      showDrawer: false,
      selectDataHtml: "",
      selectData: {},
      modal8: false,
      pageTotal: 0,
      pageSize: 30,
      selectedCondition: [],
      addressData: [],
      commandEnum: global.errorMsgParam,
      meterIdModel: "",
      openAddressModel: "",
      occurTypeModel: "",
      timeStampModel: "",
      orderWayModel: "",
      autoFreshModel: "",
      pageNo: 1,
      requestBody: {},
      interval: {}
    };
  }
};
</script>

<style>
.ivu-notice-notice {
  width: 500px;
  right: 160px;
}
.query_condition {
  border: 1px solid #c0c0c0;
  padding: 2px;
  margin: 2px;
  border-radius: 5%;
}
.check_grop div {
  margin-bottom: 1px;
}
.table table {
  table-layout: auto;
  width: 100% !important;
}
</style>